import { useWixPatternsContainer } from '../providers';
import { useSelector } from './useSelector';

export const useIsMobile = () => {
  const container = useWixPatternsContainer();
  return useSelector(() => container.isMobile);
};
